<template>
    <div class="toVipYouhuiPOp" @click="toPayVip" v-if="isYouhuiPopshow&&userInfo.vip_type!=5&&isLogin">
        <div class="toVipPopBottom">
            永久会员<br />
            即将下架

            <div class="toVipIMg">
                <img src="./images/upVipIC.gif" class="upVipICimg" alt="">
            </div>
        </div>
    </div>
</template>

<script type="text/ecmascript-6">
export default{
    data(){
        return{

        }
    },
    methods:{
        //新版弹窗逻辑
        toPayVip() {
            if (this.header_r_show==1) {
                //跳转支付
                this.$router.push('/member')
            } else if(this.header_r_show==2) {
                // this.$emit('showPayPop')
                //显示挽留支付弹框
                this.$emit('newOpen_vip')
            } else {
                //跳转支付
                this.$router.push('/member')
            }
        },

        /* 之前的逻辑 */
        // toPayVip(){
        //     if (this._type == 1){
        //         console.log(123)
        //         this.toMembdership()
        //         return
        //     }
        //     this.$http.get(`/front/user/profile/`).then(res => {
        //         if(res.data.vip_type){
        //             this.$http.get('/front/aimj/pay/today_order/').then(res => {
        //                 if(res.status==200){
        //                     this.$emit('open_vip_pop')
        //                     this.$store.commit('setYouhuiPayDeail', res.data);
        //                     this.$store.commit('setNewPayPop',true)
        //                 }else{
        //                     if(this.$route.path=='/member')return
        //                     this.$router.push('/member')
        //                 }
        //                 // this.$router.push('/member')
        //             }).catch(err=>{
                        
        //             })
        //         }else{
        //             if(this.$route.path=='/member')return
        //             this.$router.push('/member')
        //         }
        //     })

        // },
        // toMembdership(){
        //     if(this.$route.path=='/member')return
        //     this.$router.push('/member')
        // },
        // // toPayVip(){
        // //     if (this._type == 1){
        // //         console.log(123)
        // //         this.toMembdership()
        // //         return
        // //     }
        // //     this.$http.get(`/front/user/profile/`).then(res => {
        // //         if(res.data.vip_type){
        // //             this.$http.get('/front/aimj/pay/today_order/').then(res => {
        // //                 this.$emit('open_vip_pop')
        // //                 this.$store.commit('setYouhuiPayDeail', res.data);
        // //                 this.$store.commit('setNewPayPop',true)
        // //                 // this.$router.push('/member')
        // //             }).catch(err=>{
        // //             })
        // //         }else{
        // //     if(this.$route.path=='/member')return
        // //             this.$router.push('/member')
        // //         }
        // //     })

        // // }
    },
    computed:{
        isLogin() {
            return this.$store.state.isLogin;
        },
        userInfo() {
            return this.$store.state.userInfo;
        },
        header_r_show() {
            return this.$store.state.header_r_show;
        },
        isYouhuiPopshow() {
            return this.$store.state.isYouhuiPopshow;
        },
        _type() {
            return this.$store.state._type;
        },
    }
}
</script>

<style lang="scss" scoped>
.toVipYouhuiPOp{
    position: fixed;
    bottom: 230px;
    right: 20px;
    z-index: 9;
    .toVipPopBottom{
        // position: relative;
        color: #000;
        font-size: 11px;
        background: #ffcf40;
        // padding: 3px 0;
        border-radius: 4px;
        padding: 3px;
        z-index: 2;

        .toVipIMg{
            width: 48px;
            height: 48px;
            border-radius: 50%;
            border: 2px solid #ffc518;
            display: flex;
            align-items: center;
            justify-content: center;
            background: #fff;
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            z-index: -1;
            .upVipICimg{
                width: 45px;
                height: 45px;
            }
        }

    }

}
</style>